/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {ControlFunctionDTO} from './ControlFunctionDTO';
import {OperationalScopeDTO} from './OperationalScopeDTO';

/**
 * The TemplateQualitativeQuestionControlFunctionOperationalScopeDTO model module.
 * @module model/TemplateQualitativeQuestionControlFunctionOperationalScopeDTO
 * @version v0
 */
export class TemplateQualitativeQuestionControlFunctionOperationalScopeDTO {
  /**
   * Constructs a new <code>TemplateQualitativeQuestionControlFunctionOperationalScopeDTO</code>.
   * @alias module:model/TemplateQualitativeQuestionControlFunctionOperationalScopeDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TemplateQualitativeQuestionControlFunctionOperationalScopeDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TemplateQualitativeQuestionControlFunctionOperationalScopeDTO} obj Optional instance to populate.
   * @return {module:model/TemplateQualitativeQuestionControlFunctionOperationalScopeDTO} The populated <code>TemplateQualitativeQuestionControlFunctionOperationalScopeDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TemplateQualitativeQuestionControlFunctionOperationalScopeDTO();
      if (data.hasOwnProperty('controlFunction'))
        obj.controlFunction = ControlFunctionDTO.constructFromObject(data['controlFunction']);
      if (data.hasOwnProperty('operationalScope'))
        obj.operationalScope = OperationalScopeDTO.constructFromObject(data['operationalScope']);
    }
    return obj;
  }
}

/**
 * @member {module:model/ControlFunctionDTO} controlFunction
 */
TemplateQualitativeQuestionControlFunctionOperationalScopeDTO.prototype.controlFunction = undefined;

/**
 * @member {module:model/OperationalScopeDTO} operationalScope
 */
TemplateQualitativeQuestionControlFunctionOperationalScopeDTO.prototype.operationalScope = undefined;

